import { render, staticRenderFns } from "./course_card.vue?vue&type=template&id=2e81263c&scoped=true&"
import script from "./course_card.vue?vue&type=script&lang=js&"
export * from "./course_card.vue?vue&type=script&lang=js&"
import style0 from "./course_card.vue?vue&type=style&index=0&id=2e81263c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e81263c",
  null
  
)

export default component.exports